<template>
  <a-modal
    title="添加运营年度信息"
    :visible="visible"
    :mask-closable="false"
    :width="800"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :rules="validateRules"
      layout="inline"
    >
      <div class="search-form">
        <div class="search-form-left">
          <div class="form">
            <a-form-model-item
              label="基地:"
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item
              label="运营年度:"
              prop="operatorYear"
              style="width: 300px;"
            >
              <a-select
                v-model="form.operatorYear"
                placeholder="请选择运营年度"
                allow-clear
              >
                <a-select-option
                  v-for="item in operatorYearsOptions"
                  :key="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
        </div>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { addContract } from '@/api/contractInfo'
import moment from 'moment'
import { deepClone, filterOption } from '@/utils/utils.js'

const tableActions = [
  {
    title: '删除',
    type: 'link',
    action: 'delete'
  }
]

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    baseOptions: {
      type: Array,
      default: null
    },
    addInitData: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      tableActions,
      form: {
        baseName: undefined,
        baseId: undefined,
        operatorYear: undefined
      },
      validateRules: {
        baseId: [{ required: true, message: '请选择基地' }],
        operatorYear: [{ required: true, message: '请选择运营年度' }]
      },
      baseTemp: [],
      monthFormat: 'YYYY/MM',
      operatorYearsOptions: ['第1年度', '第2年度', '第3年度', '第4年度', '第5年度']
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        if (data) {
          this.form = this.deepClone(this.initData)
        }
      }
    }
  },
  methods: {
    moment,
    filterOption,
    deepClone,
    // 用逗号分隔数字
    formatter (value) {
      return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 把格式化后的字符串转换为数字
    parser (value) {
      return value.replace(/\$\s?|(,*)/g, '')
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleOk () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          addContract({
            ...this.form
          })
            .then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
        }
      })
    },
    addForm () {
      this.form.services.push({
        unit: '',
        productName: '',
        quantity: '',
        taxRatio: '',
        amountTax: '',
        amountNotTax: ''
      })
    },
    amountTaxChange (e, record, index) {
      const amountNotTax = e / (1 + Number(this.form.services[index].taxRatio) / 100)
      this.form.services[index].amountNotTax = amountNotTax.toFixed(2)
    },
    taxRatioChange (e, record, index) {
      const amountNotTax = Number(this.form.services[index].amountTax) / (1 + e / 100)
      this.form.services[index].amountNotTax = amountNotTax.toFixed(2)
    },
    async deleteContractId (record, index) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          this.form.services.splice(index, 1)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-select-selection--multiple {
  width: 300px;
}
</style>
